/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Filter_Resource_TypeInputs */

const en_audit_filter_resource_type = /** @type {(inputs: Audit_Filter_Resource_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resource type`)
};

const pt_br2_audit_filter_resource_type = /** @type {(inputs: Audit_Filter_Resource_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de recurso`)
};

/**
* | output |
* | --- |
* | "Resource type" |
*
* @param {Audit_Filter_Resource_TypeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_filter_resource_type = /** @type {((inputs?: Audit_Filter_Resource_TypeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Filter_Resource_TypeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_filter_resource_type(inputs)
	return pt_br2_audit_filter_resource_type(inputs)
});